// extracted by mini-css-extract-plugin
export default {"content":"LoyaltyRegistrationModal_content__AJhwf","content_withoutButton":"LoyaltyRegistrationModal_content_withoutButton__fEfaB","button":"LoyaltyRegistrationModal_button__s8biS"};